import React, { useEffect, useState } from "react";
import { Zoom } from "react-reveal";
import Button from "../button/Button";
import "./StaleNotice.css";

export default function StaleNotice(props) {
  const theme = props.theme;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem("staleNoticeDismissed");
    if (!dismissed) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    const openNotice = () => setVisible(true);
    window.addEventListener("open-stale-notice", openNotice);
    return () => window.removeEventListener("open-stale-notice", openNotice);
  }, []);

  function dismiss() {
    sessionStorage.setItem("staleNoticeDismissed", "true");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="stale-notice-backdrop" onClick={dismiss}>
      <Zoom duration={400}>
        <div
          className="stale-notice-card"
          style={{
            backgroundColor: theme.body,
            borderTop: `5px solid ${theme.headerColor}`,
          }}
          onClick={(event) => event.stopPropagation()}
        >
          <button
            className="stale-notice-close"
            style={{ color: theme.secondaryText }}
            onClick={dismiss}
            aria-label="Close"
          >
            &times;
          </button>
          <h3 className="stale-notice-title" style={{ color: theme.text }}>
            A quick model card
          </h3>
          <p
            className="stale-notice-body"
            style={{ color: theme.secondaryText }}
          >
            Treat this portfolio as a checkpoint, not the latest fine-tune.
            The architecture underneath is accurate. A few of the details are
            just a training run or two behind. Skip the static page and shoot
            me an email directly.
          </p>
          <Button
            text="✉️ kghelani.dev@gmail.com"
            href="mailto:kghelani.dev@gmail.com"
            theme={theme}
            className="stale-notice-btn-wrap"
          />
          <button
            className="stale-notice-dismiss-text"
            style={{ color: theme.secondaryText }}
            onClick={dismiss}
          >
            Run inference anyway
          </button>
        </div>
      </Zoom>
    </div>
  );
}
